export enum ReachLevel {
	ADMIN = 3,
	BENEFICIARY = 5,
	FINANCIAL = 7,
	HEALTH = 6,
	MASTER = 2,
	OPERATOR = 4,
	SUPER_USER = 1,
}
